@if (title) {
  <div class="mb-4 text-xl font-semibold">
    {{ title }}
  </div>
}

<div class="flex rounded-lg bg-aux-gray-light p-4">
  <aux-input
    #notesTextArea
    class="flex-grow"
    inputClassName="resize-none max-h-64 border-0 bg-transparent !outline-none !shadow-none w-full !max-w-full !text-lg text-aux-gray-darkest !font-normal"
    resize="false"
    [textArea]="true"
    [rows]="1"
    [formControl]="notesControl"
    [placeholder]="placeholder"
    [textareaAutoresize]="true"
    [disabled]="!editMode"
  />

  <div class="flex w-[150px] min-w-[150px] items-start justify-end pt-0.5">
    @if (editMode) {
      <aux-button class="mr-2" variant="primary" label="Save" (click)="onSave()" />

      <aux-button variant="secondary" classList="text-sm" label="Cancel" (click)="cancel()" />
    } @else {
      <aux-button
        variant="custom"
        icon="Pencil"
        svgAttributes="text-aux-blue"
        [classList]="classListForEdit"
        [ngClass]="{
          'cursor-not-allowed opacity-50': !hasEditPermission,
        }"
        type="button"
        [auxTooltip]="!hasEditPermission ? disabledTooltipText : ''"
        [disabled]="!hasEditPermission"
        (click)="edit()"
      />
    }
  </div>
</div>
